
import {createAsyncThunk, createSlice, current} from '@reduxjs/toolkit';

const initialState = {
    rechargeUserInfo: ""
};

export const userManagerSlice = createSlice({
    name: 'userManager',
    initialState,
    reducers: {
        setRechargeUserInfo: (state,action) => {
            state.rechargeUserInfo = action.payload;
        }
    },
});

export const selectRechargeUserInfo = (state) => state.userManager.rechargeUserInfo;
export const {
    setRechargeUserInfo
} = userManagerSlice.actions;

export default userManagerSlice.reducer;
